import _ from 'lodash'
import {
  SET_PORTAL,
  CHANGE_PORTAL,
  SET_PROFILE_IMAGE,
  SET_PROFILE_IMAGE_ERROR,
  UPDATE_PROFILE_IMAGE,
  UPDATE_PROFILE_IMAGE_ERROR,
  REMOVE_PROFILE_IMAGE,
  REMOVE_PROFILE_IMAGE_ERROR,
  ADD_GALLERY_IMAGE,
  ADD_GALLERY_IMAGE_ERROR,
  REMOVE_GALLERY_IMAGE,
  REMOVE_GALLERY_IMAGE_ERROR,
  UPDATE_GALLERY_IMAGE,
  UPDATE_GALLERY_IMAGE_ERROR,
  UPDATE_GALLERY_IMAGES,
  UPDATE_GALLERY_IMAGES_ERROR,
  ADD_LINK_IMAGE,
  ADD_LINK_IMAGE_ERROR,
  REMOVE_LINK_IMAGE,
  REMOVE_LINK_IMAGE_ERROR,
  UPDATE_LINK_IMAGE,
  UPDATE_LINK_IMAGES,
  UPDATE_LINK_IMAGES_ERROR,
  COPY_CONTENT_FROM_LANGUAGE,
} from '../constants/actions'
import {
  uploadPortalImage,
  removePortalImage,
} from '../modules/portal-remote/portalImageService'
import { updatePortal } from '../modules/portal-remote/portalService'
import config from '../config'

export const setPortal = portal => ({
  type: SET_PORTAL,
  portal,
})

export const changePortal = (path, value) => ({
  type: CHANGE_PORTAL,
  path,
  value,
})

export const setProfileImage = imageFile => async (dispatch, getState) => {
  try {
    const { _id: portalID } = getState().portal
    const {
      ref: mainImageId,
      lastChecked: mainImageLastChecked,
    } = await uploadPortalImage(portalID, imageFile)
    await updatePortal({ _id: portalID, mainImageId, mainImageLastChecked })
    dispatch({ type: SET_PROFILE_IMAGE, mainImageId, mainImageLastChecked })
  } catch ({ message }) {
    dispatch({ type: SET_PROFILE_IMAGE_ERROR, message })
  }
}

export const updateProfileImage = (
  imageFile,
  repalceImageID,
  originalImageID,
) => async (dispatch, getState) => {
  try {
    const { _id: portalID } = getState().portal
    const {
      ref: mainImageId,
      lastChecked: mainImageLastChecked,
    } = await uploadPortalImage(portalID, imageFile, repalceImageID, originalImageID)
    dispatch({ type: UPDATE_PROFILE_IMAGE, mainImageId, mainImageLastChecked })
  } catch ({ message }) {
    dispatch({ type: UPDATE_PROFILE_IMAGE_ERROR, message })
  }
}

export const removeProfileImage = () => async (dispatch, getState) => {
  try {
    const { _id: portalID, mainImageId } = getState().portal
    await removePortalImage(portalID, mainImageId)
    await updatePortal({ _id: portalID, mainImageId: null })
    dispatch({
      type: REMOVE_PROFILE_IMAGE,
      mainImageId: undefined,
      mainImageLastChecked: undefined,
    })
  } catch ({ message }) {
    dispatch({ type: REMOVE_PROFILE_IMAGE_ERROR, message })
  }
}

export const addGalleryImage = imageFile => async (dispatch, getState) => {
  try {
    const {
      _id: portalID,
      galleryImages: _galleryImages = [],
    } = getState().portal
    const { ref: mainImageId, lastChecked } = await uploadPortalImage(
      portalID,
      imageFile,
    )

    const galleryImage = {
      mainImageId,
      title: config.getLangText(),
      lastChecked,
    }

    const galleryImages = [..._galleryImages, galleryImage]
    await updatePortal({ _id: portalID, galleryImages })
    dispatch({ type: ADD_GALLERY_IMAGE, galleryImages })
  } catch ({ message }) {
    dispatch({ type: ADD_GALLERY_IMAGE_ERROR, message })
  }
}

export const updateGalleryImages = galleryImages => async (
  dispatch,
  getState,
) => {
  try {
    const { _id: portalID } = getState().portal
    await updatePortal({ _id: portalID, galleryImages })
    dispatch({ type: UPDATE_GALLERY_IMAGES, galleryImages })
  } catch ({ message }) {
    dispatch({ type: UPDATE_GALLERY_IMAGES_ERROR, message })
  }
}

export const updateGalleryImage = (
  galleryImage,
  imageFile,
  originalImageID,
) => async (dispatch, getState) => {
  try {
    const {
      _id: portalID,
      galleryImages: _galleryImages = [],
    } = getState().portal

    const _galleryImage = _.find(_galleryImages, {
      mainImageId: galleryImage.mainImageId,
    })
    const replaceImageID = _galleryImage.mainImageId

    if (imageFile) {
      const { ref: mainImageId, lastChecked } = await uploadPortalImage(
        portalID,
        imageFile,
        replaceImageID,
        originalImageID,
      )
      galleryImage = {
        ..._galleryImage,
        mainImageId,
        lastChecked,
      }
    }

    const galleryImages = _.map(_galleryImages, _galleryImage => {
      if (_galleryImage.mainImageId === galleryImage.mainImageId) {
        return {
          ..._galleryImage,
          ...galleryImage,
        }
      }
      return _galleryImage
    })

    await updatePortal({ _id: portalID, galleryImages })
    dispatch({ type: UPDATE_GALLERY_IMAGE, galleryImages })
  } catch ({ message }) {
    dispatch({ type: UPDATE_GALLERY_IMAGE_ERROR, message })
  }
}

export const removeGalleryImage = imageID => async (dispatch, getState) => {
  try {
    const { _id: portalID, galleryImages: _galleryImages } = getState().portal
    await removePortalImage(portalID, imageID)

    const galleryImages = _.reject(_galleryImages, { mainImageId: imageID })

    await updatePortal({ _id: portalID, galleryImages })
    dispatch({ type: REMOVE_GALLERY_IMAGE, galleryImages })
  } catch ({ message }) {
    dispatch({ type: REMOVE_GALLERY_IMAGE_ERROR, message })
  }
}

export const addLinkImage = imageFile => async (dispatch, getState) => {
  try {
    const { _id: portalID, links: _links = [] } = getState().portal
    const { ref: mainImageId, lastChecked } = await uploadPortalImage(
      portalID,
      imageFile,
    )

    const link = {
      title: config.getLangText(),
      externalUrl: null,
      mainImageId,
      lastChecked,
    }

    const links = [..._links, link]
    await updatePortal({ _id: portalID, links })
    dispatch({ type: ADD_LINK_IMAGE, links })
  } catch ({ message }) {
    console.log('add link image error', message)
    dispatch({ type: ADD_LINK_IMAGE_ERROR, message })
  }
}

export const updateLinkImage = (link, imageFile, originalImageID) => async (
  dispatch,
  getState,
) => {
  try {
    const { _id: portalID, links: _links = [] } = getState().portal

    const _link = _.find(_links, { mainImageId: link.mainImageId })
    const replaceImageID = link.mainImageId

    if (imageFile) {
      const { ref: mainImageId, lastChecked } = await uploadPortalImage(
        portalID,
        imageFile,
        replaceImageID,
        originalImageID,
      )

      link = {
        ..._link,
        ...link,
        mainImageId,
        lastChecked,
      }
    }

    const links = _.map(_links, _link => {
      if (_link.mainImageId === link.mainImageId) {
        return {
          ..._link,
          ...link,
        }
      }
      return _link
    })

    await updatePortal({ _id: portalID, links })
    dispatch({ type: UPDATE_LINK_IMAGE, links })
  } catch ({ message }) {
    dispatch({ type: UPDATE_GALLERY_IMAGE_ERROR, message })
  }
}

export const updateLinkImages = links => async (dispatch, getState) => {
  try {
    const { _id: portalID } = getState().portal
    await updatePortal({ _id: portalID, links })
    dispatch({ type: UPDATE_LINK_IMAGES, links })
  } catch ({ message }) {
    dispatch({ type: UPDATE_LINK_IMAGES_ERROR, message })
  }
}

export const removeLinkImage = imageID => async (dispatch, getState) => {
  try {
    const { _id: portalID, links: _links } = getState().portal
    await removePortalImage(portalID, imageID)

    const links = _.reject(_links, { mainImageId: imageID })
    await updatePortal({ _id: portalID, links })
    dispatch({ type: REMOVE_LINK_IMAGE, links })
  } catch ({ message }) {
    dispatch({ type: REMOVE_LINK_IMAGE_ERROR, message })
  }
}

export const copyPortalFromLang = (langFrom, langTo) => {
  return {
    type: COPY_CONTENT_FROM_LANGUAGE,
    langFrom,
    langTo,
  }
}



// WEBPACK FOOTER //
// ./src/actions/portal.js